export default __webpack_public_path__ + "img/icon-flag-pt.asset.826ac1d7.jpg";